import { createSlice } from '@reduxjs/toolkit';

export const LogSlice = createSlice({
    name: 'log',
    initialState: {
        logs_list: [],
        log: {}
    },
    reducers: {
        setLogsRedux: ( state, { payload } ) => {
            state.logs_list  =  payload;
        }, 
        storeLogRedux: ( state, { payload } ) => {
            state.log  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setLogsRedux, storeLogRedux } = LogSlice.actions;